import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import merge from 'lodash/merge';
import R from '../../../core-res/R';
import DRNButton from '../../Button/DRNButton';
import DRNText from '../../../standard/Text/DRNText';
import DRNImage from '../../Image/DRNImage';
// Variant
const POSITIVE = 'POSITIVE';
const SUBTLE_POSITIVE = 'SUBTLE_POSITIVE';
const ALERT = 'ALERT';
const SUBTLE_ALERT = 'SUBTLE_ALERT';
const WARNING = 'WARNING';
const SUBTLE_WARNING = 'SUBTLE_WARNING';
// TODO: Deprecate this type (will be replaced by variant props)
const SUCCESS = 'SUCCESS';
const SUBTLE_SUCCESS = 'SUBTLE_SUCCESS';
const ERROR = 'ERROR';
const SUBTLE_ERROR = 'SUBTLE_ERROR';
export default class Snackbar extends Component {
    componentDidMount() {
        if (this.props.type) {
            console.warn('Using "type" props at Snackbar V2 will be deprecated. Please use "variant" props instead');
        }
    }
    getStyleByVariant() {
        const { type, variant } = this.props;
        return stylesByVariant[type || variant];
    }
    render() {
        const { message, style = {}, actionType, actionText, actionIconUrl, actionOnPress } = this.props;
        const styles = merge({}, _styles, this.getStyleByVariant());
        const Tag = actionType === 'text' ? DRNButton : DRNButton.Icon;
        return (<View style={[styles.container, style]}>
        <DRNText style={styles.message} numberOfLines={2}>
          {message}
        </DRNText>
        <View style={styles.actionContainer}>
          <Tag onPress={actionOnPress} buttonStyle={Object.assign({}, R.style.buttonText, { textColors: {
                disabled: styles.actionText.color,
                pressed: styles.actionText.color,
                active: styles.actionText.color,
            } })} text={actionType === 'text' && actionText} textSize={'small'} Icon={() => {
            if (actionType === 'icon')
                return (<DRNImage source={actionIconUrl ? { uri: actionIconUrl } : require('../../../../images/icSysCrossClose.png')} style={{ width: 24, height: 24, tintColor: styles.actionText.color }}/>);
        }}/>
        </View>
      </View>);
    }
}
Snackbar.propTypes = {
    message: PropTypes.string.isRequired,
    actionType: PropTypes.oneOf(['text', 'icon']),
    actionText: PropTypes.string,
    actionIconUrl: PropTypes.string,
    actionOnPress: PropTypes.func,
    type: PropTypes.oneOf([SUCCESS, ERROR, WARNING, SUBTLE_SUCCESS, SUBTLE_ERROR, SUBTLE_WARNING]),
    variant: PropTypes.oneOf([POSITIVE, SUBTLE_POSITIVE, ALERT, SUBTLE_ALERT, WARNING, SUBTLE_WARNING]),
};
Snackbar.defaultProps = {
    message: '',
    actionType: 'text',
    actionText: 'Close',
    actionIconUrl: '',
    variant: POSITIVE,
};
const _styles = {
    container: Object.assign({ margin: R.spacing.xxs, borderRadius: R.border.radius.default }, R.elevation.hover, { borderWidth: R.border.width.thin, paddingHorizontal: R.spacing.s, paddingTop: R.spacing.s, paddingBottom: R.spacing.xxs }),
    message: Object.assign({ color: R.color.uiLightPrimary }, R.typography.uiSmall),
    actionText: {
        color: R.color.uiLightPrimary,
    },
    actionIconUrl: {
        width: 24,
        height: 24,
        marginLeft: R.spacing.l,
    },
    actionContainer: {
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
    },
};
const stylesByVariant = {
    [POSITIVE]: {
        container: {
            backgroundColor: R.color.uiGreenSecondary,
            borderColor: R.color.uiGreenDark,
        },
        actionText: {
            color: R.color.uiLightPrimary,
        },
    },
    [SUBTLE_POSITIVE]: {
        container: {
            backgroundColor: R.color.uiGreenLight,
            borderColor: R.color.uiGreenPrimary,
        },
        message: {
            color: R.color.uiGreenDark,
        },
        actionText: {
            color: R.color.uiDarkNeutral,
        },
    },
    [ALERT]: {
        container: {
            backgroundColor: R.color.uiRedSecondary,
            borderColor: R.color.uiRedDark,
        },
        actionText: {
            color: R.color.uiLightPrimary,
        },
    },
    [SUBTLE_ALERT]: {
        container: {
            backgroundColor: R.color.uiRedLight,
            borderColor: R.color.uiRedPrimary,
        },
        message: {
            color: R.color.uiRedDark,
        },
        actionText: {
            color: R.color.uiDarkNeutral,
        },
    },
    [WARNING]: {
        container: {
            backgroundColor: R.color.uiYellowPrimary,
            borderColor: R.color.uiYellowSecondary,
        },
        message: {
            color: R.color.textPrimary,
        },
        actionText: {
            color: R.color.textPrimary,
        },
    },
    [SUBTLE_WARNING]: {
        container: {
            backgroundColor: R.color.uiYellowLight,
            borderColor: R.color.uiYellowPrimary,
        },
        message: {
            color: R.color.uiYellowDark,
        },
        actionText: {
            color: R.color.uiDarkNeutral,
        },
    },
    // TODO: Deprecate this style
    [SUCCESS]: {
        container: {
            backgroundColor: R.color.uiGreenSecondary,
            borderColor: R.color.uiGreenDark,
        },
        actionText: {
            color: R.color.uiLightPrimary,
        },
    },
    [SUBTLE_SUCCESS]: {
        container: {
            backgroundColor: R.color.uiGreenLight,
            borderColor: R.color.uiGreenPrimary,
        },
        message: {
            color: R.color.uiGreenDark,
        },
        actionText: {
            color: R.color.uiDarkNeutral,
        },
    },
    [ERROR]: {
        container: {
            backgroundColor: R.color.uiRedSecondary,
            borderColor: R.color.uiRedDark,
        },
        actionText: {
            color: R.color.uiLightPrimary,
        },
    },
    [SUBTLE_ERROR]: {
        container: {
            backgroundColor: R.color.uiRedLight,
            borderColor: R.color.uiRedPrimary,
        },
        message: {
            color: R.color.uiRedDark,
        },
        actionText: {
            color: R.color.uiDarkNeutral,
        },
    },
};
